import { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { SnowThemeTitle } from "../../../../Constants/Constants";
import { SnowThemeContent } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ReactQuill from "react-quill-new";

const SnowTheme = () => {
  const [value, setValue] = useState(SnowThemeContent);
  return (
    <Row>
      <Col sm="12">
        <Card>
          <CommonCardHeader title={SnowThemeTitle} />
          <CardBody>
            <ReactQuill theme="snow" value={value} onChange={setValue} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
export default SnowTheme;
